import { render, staticRenderFns } from "./SidebarPanelAuctionItem.vue?vue&type=template&id=7d38d7db&"
import script from "./SidebarPanelAuctionItem.vue?vue&type=script&lang=js&"
export * from "./SidebarPanelAuctionItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPanelAuctionItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports